import {
  WAvatar,
  WBadge,
  WBanner,
  WButton,
  WButtonGroup,
  WCard,
  WCheckbox,
  WCollapse,
  WCombobox,
  WDivider,
  WDropdown,
  WEmptyState,
  WFieldset,
  WFileUpload,
  WGrid,
  WGridItem,
  WIcon,
  WIconButton,
  WInput,
  WLayout,
  WLayoutMain,
  WLayoutMainContent,
  WLayoutMainHeader,
  WLayoutSidebar,
  WLink,
  WModal,
  WNavList,
  WPagination,
  WPopover,
  WProgressBar,
  WRadio,
  WSelect,
  WSkeleton,
  WSpacer,
  WSpinner,
  WStack,
  WStackItem,
  WStepIndicator,
  WTable,
  WTableBody,
  WTableBodyCell,
  WTableBodyRow,
  WTableHead,
  WTableHeadCell,
  WTabPanel,
  WTabs,
  WTabsItem,
  WText,
  WTextarea,
  WToast,
  WToggle,
  WTooltip,
} from "@dp-watson-web/components";

import "@dp-watson-web/components/dist/watson.css";

export default {
  install(app: { component: (arg0: string, arg1: unknown) => void }) {
    // Register all components globally

    // Avatar
    app.component(WAvatar.name, WAvatar);

    // Badge
    app.component(WBadge.name, WBadge);

    // Banner
    app.component(WBanner.name, WBanner);

    // Buttons
    app.component(WButton.name, WButton);
    app.component(WButtonGroup.name, WButtonGroup);

    // Card
    app.component(WCard.name, WCard);

    // Checkbox
    app.component(WCheckbox.name, WCheckbox);

    // Collapse
    app.component(WCollapse.name, WCollapse);

    // Combobox
    app.component(WCombobox.name, WCombobox);

    // Divider
    app.component(WDivider.name, WDivider);

    // Dropdown
    app.component(WDropdown.name, WDropdown);

    // Empty state
    app.component(WEmptyState.name, WEmptyState);

    // Fieldset
    app.component(WFieldset.name, WFieldset);

    // FileUpload
    app.component(WFileUpload.name, WFileUpload);

    // Grid
    app.component(WGrid.name, WGrid);
    app.component(WGridItem.name, WGridItem);

    // Icon
    app.component(WIcon.name, WIcon);
    app.component(WIconButton.name, WIconButton);

    // Input
    app.component(WInput.name, WInput);

    // Layout
    app.component(WLayout.name, WLayout);
    app.component(WLayoutSidebar.name, WLayoutSidebar);
    app.component(WLayoutMain.name, WLayoutMain);
    app.component(WLayoutMainHeader.name, WLayoutMainHeader);
    app.component(WLayoutMainContent.name, WLayoutMainContent);

    // Link
    app.component(WLink.name, WLink);

    // Modal
    app.component(WModal.name, WModal);

    // Navigation List
    app.component(WNavList.name, WNavList);

    // Pagination
    app.component(WPagination.name, WPagination);

    // Popover
    app.component(WPopover.name, WPopover);

    // Progress bar
    app.component(WProgressBar.name, WProgressBar);

    // Radio
    app.component(WRadio.name, WRadio);

    // Select
    app.component(WSelect.name, WSelect);

    // Skeleton
    app.component(WSkeleton.name, WSkeleton);

    // Spacer
    app.component(WSpacer.name, WSpacer);

    // Spinner
    app.component(WSpinner.name, WSpinner);

    // Stack
    app.component(WStack.name, WStack);
    app.component(WStackItem.name, WStackItem);

    // Step indicator
    app.component(WStepIndicator.name, WStepIndicator);

    // Table
    app.component(WTable.name, WTable);
    app.component(WTableHead.name, WTableHead);
    app.component(WTableHeadCell.name, WTableHeadCell);
    app.component(WTableBody.name, WTableBody);
    app.component(WTableBodyRow.name, WTableBodyRow);
    app.component(WTableBodyCell.name, WTableBodyCell);

    // Tabs
    app.component(WTabs.name, WTabs);
    app.component(WTabsItem.name, WTabsItem);
    app.component(WTabPanel.name, WTabPanel);

    // Text
    app.component(WText.name, WText);

    // Textarea
    app.component(WTextarea.name, WTextarea);

    // Toast
    app.component(WToast.name, WToast);

    // Toggle
    app.component(WToggle.name, WToggle);

    // Tooltip
    app.component(WTooltip.name, WTooltip);

    // Pull for all other required global components
  },
};
